export default __webpack_public_path__ + "static/media/token-swap-success.c0f3bb5e.png";